import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Main, BlogPage, ProjectPage } from "./pages";
import { BackToTop } from "./components";

import "./App.css";

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/projects" element={<ProjectPage />} />
        </Routes>
        <BackToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;
